import React from "react";
import { FeatureRole, XolaMobileApp } from "types";
import { useSeller, useUser } from "../../hooks/useAccount";
import { hasFeature } from "../../models/Seller";
import { isAffiliate } from "../../models/User";
import { CustomMenuItems } from "./CustomMenuItems";
import { MenuItem } from "./MenuItem";
import { useXolaMobileApps } from "@/components/MobileApps/XolaMobileAppsContext";
import { config } from "@/config";
import { getPermissions } from "@/stores/globalStore";

export const SettingMenuItems = () => {
    const seller = useSeller();
    const user = useUser();
    const permissions = getPermissions(); // Fetch permissions using getPermissions

    const shouldShowHardwareSettings = isAffiliate(user) ? hasFeature(seller, FeatureRole.EMV) : true;
    const { xolaMobileApp } = useXolaMobileApps();
    const shouldShowAccountOrMyLanguage = permissions.canViewCompanyBasicInfo || seller.preferences.language.multiple;
    const shouldShowLanguageSettings =
        permissions.canViewMultiLanguageSupport || (config.localize.enabled && shouldShowAccountOrMyLanguage);

    return (
        <>
            {permissions.canViewCompanyProfile && (
                <MenuItem isSubMenuItem route="settings/company" label="Company Profile" />
            )}
            <MenuItem isSubMenuItem route="settings/profile" label="My Profile" />
            {permissions.canViewGuideProfile && (
                <MenuItem isSubMenuItem route="settings/guideProfile" label="Guide Profile" />
            )}
            {permissions.canViewAccessManager && (
                <MenuItem isSubMenuItem route="settings/users" label="Users &amp; Access" />
            )}
            {shouldShowLanguageSettings && <MenuItem isSubMenuItem route="settings/languages" label="Languages" />}
            {permissions.canViewNotificationSettings && (
                <MenuItem isSubMenuItem route="settings/notifications" label="Notifications" />
            )}
            {permissions.canViewButtonCode && <MenuItem isSubMenuItem route="settings/buttons" label="Button Code" />}
            {permissions.canViewPreferencesSettings && (
                <MenuItem isSubMenuItem route="settings/preferences" label="Preferences" />
            )}
            {permissions.canViewPreferencesSettings && (
                <MenuItem isSubMenuItem route="settings/fraudFighter" label="Fraud Fighter" />
            )}
            {permissions.canViewGratuitySettings && (
                <MenuItem isSubMenuItem route="settings/gratuity" label="Gratuity" />
            )}
            {permissions.canViewAppsSettings && <MenuItem isSubMenuItem route="settings/apps" label="Apps" />}
            {permissions.canViewTaxesAndFees && (
                <MenuItem isSubMenuItem route="settings/taxesAndFees" label="Taxes &amp; Fees" />
            )}
            {permissions.canViewPaymentsSettings && (
                <MenuItem isSubMenuItem route="settings/payments" label="Payments" />
            )}
            {permissions.canViewHardware && shouldShowHardwareSettings && (
                <>
                    <MenuItem isSubMenuItem route="settings/hardware" label="Hardware" />
                    <MenuItem isSubMenuItem route="settings/kiosk" label="Kiosk" />
                </>
            )}
            {xolaMobileApp === XolaMobileApp.XolaTablet && (
                <MenuItem isSubMenuItem route="settings/tabletApp" label="Tablet App" />
            )}
            <CustomMenuItems route="settings" />
        </>
    );
};
